export default __webpack_public_path__ + "static/media/insta.1b4400ea.svg";